import { LanguageName } from "@axon-enterprise/i18n";

// Supported languages based on available translation files
// Only include languages that have corresponding locale files in src/i18n/locales/
export const SUPPORTED_LANGUAGES: LanguageName[] = [
  LanguageName.English_US, // "en-us" - has locale file
  // LanguageName.French_CA, // "fr-ca" - not in LOCALE_MAP, no locale file
  LanguageName.Spanish, // "es" - has locale file
  // LanguageName.Slovak, // "sk" - not in LOCALE_MAP, no locale file
];

